import React from 'react';
import {Modal, Button} from 'semantic-ui-react';
const ModalComfirm = ({handleModal, open, handleNotification}) => {
  return (
    <Modal size='mini' open={open}>
      <Modal.Header>Confirmación cálculo de precios</Modal.Header>
      <Modal.Content>
      ¿ Esta seguro que desea ejecutar cálculo de precios?
      
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleModal}>
          Cerrar
        </Button>
        <Button onClick={handleNotification} color='green'>
          Procesar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
export default ModalComfirm;
